import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { Owner, StoreApplicant } from '@funnels/types';

export const hasPartialOwnershipByApplicantType = (
  formValues: Object,
  value: Owner[] = [],
  targetApplicantType?: string
) => {
  const applicantOwners = value.filter((owner: Owner) => !!owner.applicantId); // exclude Non-applicant
  // we need to treat no ownership as part owner for initialized data in F1
  return (
    applicantOwners.length === 0 ||
    applicantOwners.some((b: Owner) => {
      const applicants = get(formValues, FIELD_PATHS.APPLICANTS());
      const applicantOwner = applicants.find(
        (applicant: StoreApplicant) => get({ applicants: [applicant] }, FIELD_PATHS.APPLICANT_ID(0)) === b.applicantId
      );
      const applicantType = get({ applicants: [applicantOwner] }, FIELD_PATHS.APPLICANT_TYPE(0));
      return applicantOwner && applicantType === targetApplicantType && b.percent > 0;
    })
  );
};
